import { isAdvisorScopeRoleId } from '@steward-app/steward-types';
import { isWorkspaceAdmin } from '../api/types';

/**
 * True for a membership that carries an advisor-scope role and is not a workspace admin: a firm
 * advisor standing in a family workspace. Both firm cash flow roles hold `cash-flow:agreement`,
 * but an advisor has no FAMILY level, so Setup is not theirs to see (steward-app#2592; the façade
 * narrows `GET /cash-flow/agreement` for them in slice 10). The same rule as the façade's advisor
 * test (`isAdvisorScopeRoleId`). UX gating: appcore and the façade enforce regardless.
 */
export function isAdvisorWithoutAdmin(roleIds: readonly string[]): boolean {
  return roleIds.some(isAdvisorScopeRoleId) && !isWorkspaceAdmin([...roleIds]);
}
